<template>
  <v-container
    id="lista-produtos-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <!-- FORMULARIO DE USUARIO NAO IDENTIFICADO ------------------------------------------------->
        <usuario-nao-identificado-form
          v-if="!usuarioIdentificado"
          :titulo="$t('lista-produtos')"
        />
        <base-material-card
          v-else
          :color="corPrimaria"
          :title="$t('lista-produtos')"
          :app-online="appOnline"
          class="py-3 px-5"
        >
          <template v-slot:heading>
            <div
              class="text-h3 font-bold-light"
            >
              <v-icon
                id="iconShopping"
                class="text-h2"
              >
                mdi-shopping
              </v-icon>
              Lista de Produtos
            </div>
          </template>
        </base-material-card>
        <v-divider class="mb-5" />
        <v-row>
          <v-col
            cols="12"
            lg="3"
          >
            <div class="col-12">
              <div v-if="linhaProducaoOk">
                <h3>Linha de Produtos</h3>
                <hr><br>
                <ul
                  id="line_product"
                >
                  <li
                    v-for="linhaproducao in listalinhasproducao"
                    :key="linhaproducao.id"
                    class="col-12"
                  >
                    <input
                      id="linhaproducao"
                      v-model="linhaselected"
                      :name="linhaproducao.nome"
                      :value="linhaproducao.id"
                      type="checkbox"
                      @change="filtrar()"
                    >
                    {{ linhaproducao.nome }}
                  </li>
                </ul>
              </div>
              <div v-if="classificacaoOk">
                <h3>Classificação</h3>
                <hr><br>
                <ul
                  id="classi"
                >
                  <li
                    v-for="classificacao in listaclassificacao"
                    :key="classificacao.id"
                    class="col-12"
                  >
                    <input
                      id="classificacao"
                      v-model="classificacaoselected"
                      :name="classificacao"
                      :value="classificacao.id"
                      type="checkbox"
                      @change="filtrar()"
                    >
                    {{ classificacao.nome }}
                  </li>
                </ul>
              </div>
              <hr><br>
            </div>
          </v-col>
          <v-col
            cols="12"
            lg="9"
          >
            <div class="col-12">
              <br>
              <div>
                <ul
                  id="ul_product"
                >
                  <li
                    v-for="produto in produtos"
                    id="li_product"
                    :key="produto.id"
                    class="col-12 lg-6 mb-4 my-2"
                  >
                    <div
                      v-if="!produto.unidade"
                    >
                      <h5>
                        <b>{{ produto.nome }}</b>
                      </h5>
                    </div>
                    <div
                      v-else
                    >
                      <div
                        v-if="produto.imagem"
                        id="imagemProduto"
                      >
                        <v-img
                          id="imagem"
                          :src="produto.imagem"
                          contain
                        />
                      </div>
                      <div
                        id="nomeProduto"
                        class="text-left"
                      >
                        {{ produto.nome }} ({{ produto.unidade }}) <br>
                      </div>
                      <div
                        v-if="produto.referenciaUnidade !== 1"
                        id="exibirReferenciaUnidade"
                        class="text-left"
                      >
                        Aproximadamente {{ produto.referenciaUnidadeExibicao }} {{ produto.unidade }} por peça
                      </div>
                      <div
                        v-else
                        id="nomeProdutoReferencia"
                      >
                        {{ produto.referenciaUnidadeExibicao }} {{ produto.unidade }} por peça
                      </div>
                      <span id="precoProduto"> R$ {{ produto.precoExibicao }}/{{ produto.unidade }}
                      </span>
                      <v-row>
                        <v-btn
                          id="btnDetalhe"
                          class="col-3 lg-6"
                          small
                          :color="corPrimaria"
                          dark
                          @click="showDescricao(produto)"
                        >
                          Ver mais
                        </v-btn>
                        <v-btn
                          id="btnProduto"
                          class="col-3 lg-6"
                          small
                          :color="corPrimaria"
                          dark
                          @click="addItem(produto)"
                        >
                          Adicionar
                        </v-btn>
                      </v-row>
                    </div>
                  </li>
                </ul>
                <v-pagination
                  v-if="paginaVisible"
                  v-model="pagina"
                  :length="limitePagina"
                  circle
                  @input="carregaPagina(pagina)"
                />
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    >
      {{ snackbar.message }}
    </dashboard-core-snackbar>
  </v-container>
</template>

<script>
  import ListaProdutos from '../../../services/listaprodutosservice'
  import Carrinho from '../../../services/carrinhoservice'
  import utils from '../../../services/utils'

  export default {
    name: 'PageListaProdutos',
    emits: ['updateCart'],
    components: {
      DashboardCoreSnackbar: () => import('../components/core/Snackbar'),
    },
    mixins: [utils],

    data: () => ({
      appOnline: navigator.onLine,
      produtos: [],
      listaclassificacao: [],
      listalinhasproducao: [],
      classificacaoselected: [],
      linhaselected: [],
      produtoNomes: [],
      carrinho: [],
      bloqueado: localStorage.bloqueado,
      obsBloqueado: localStorage.obsBloqueado,
      inativo: 0,
      itensCarrinho: [],
      imagem: localStorage.imagem,
      consultar: [],
      loading_produtos: false,
      usuarioIdentificado: true,
      classificacaoOk: false,
      linhaProducaoOk: false,
      valid: true,
      countProdutos: 0,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      styleObjectError: {
        color: '#FFFFFF',
      },
      cart: 0,
      produtoid: 0,
      limitePagina: 0,
      pagina: 1,
      paginaVisible: false,
      corPrimaria: localStorage.corPrimaria,
    }),

    mounted () {
      if (localStorage.chaveativacao && localStorage.chaveativacao !== 'undefined') {
        this.chaveativacao = localStorage.chaveativacao
        if (localStorage.getItem('usuarioIdentificado') && localStorage.getItem('usuarioIdentificado') === 'true') {
          this.usuarioIdentificado = true

          this.carregaForm()
          this.carregaClassificacao()
          this.carregaLinhaProducao()

          this.classificacaoselected = localStorage.classificacaoSelect ? JSON.parse(localStorage.classificacaoSelect) : []
          this.linhaselected = localStorage.linhaSelect ? JSON.parse(localStorage.linhaSelect) : []

          if (this.classificacaoselected.length > 0 && this.linhaselected.length === 0) {
            this.carregaProdutosClassificacao(this.classificacaoselected)
          } else if (this.linhaselected.length > 0 && this.classificacaoselected.length === 0) {
            this.carregaProdutosLinha(this.linhaselected)
          } else if (this.classificacaoselected.length > 0 && this.linhaselected.length > 0) {
            this.carregaProdutosLinhaClassificacao(this.linhaselected, this.classificacaoselected)
          } else {
            this.carregaProdutos()
          }

          localStorage.removeItem('produtoId')
          localStorage.removeItem('linhaSelect')
          localStorage.removeItem('classificacaoSelect')
        } else {
          this.usuarioIdentificado = false
          localStorage.removeItem('username')
          localStorage.removeItem('produtoId')
          localStorage.removeItem('email')
          localStorage.removeItem('nome')
          this.$router.push('/login')
        }
      } else {
        localStorage.removeItem('username')
        localStorage.removeItem('produtoId')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      carregaForm () {
        this.loading_produtos = true

        localStorage.removeItem('carrinhoId')

        Carrinho.show(localStorage.username, localStorage.tokencontrato).then(resposta => {
          this.itensCarrinho = resposta.data.itensCarrinho
          if (this.itensCarrinho) {
            this.produtoNomes = this.itensCarrinho
            this.cart = this.produtoNomes.length
            this.bloqueado = resposta.data.bloqueado
            this.inativo = resposta.data.inativo

            localStorage.bloqueado = this.bloqueado
            localStorage.inativo = this.inativo

            localStorage.setItem('carrinhoId', this.itensCarrinho[0].carrinhoId)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else {
            this.showSnackbar('error', 3000, e.response.data.mensagem + ' - Erro ao carregar informações')
          }
        })
      },

      async carregaProdutos () {
        this.loading_produtos = true

        await ListaProdutos.show(localStorage.username, localStorage.contrato_id, this.pagina).then(resposta => {
          if (resposta.data.status) {
            this.produtos = resposta.data.produto

            if (resposta.data.limitePagina > 1) {
              this.paginaVisible = true
              this.limitePagina = resposta.data.limitePagina
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else {
            this.showSnackbar('error', 3000, e.response.data.mensagem + ' - Erro ao carregar informações')
            this.$router.push('/')
          }
          this.loading_produtos = false
        })
      },

      carregaPagina (value) {
        this.pagina = value
        this.carregaProdutos()
      },

      async carregaLinhaProducao () {
        this.loading_produtos = true
        await ListaProdutos.listarLinhaProducao(localStorage.contrato_id).then(resposta => {
          if (resposta.data.status === true) {
            this.listalinhasproducao = resposta.data.linhaproducao
            this.linhaProducaoOk = resposta.data.status
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else {
            this.showSnackbar('error', 3000, e.response.data.mensagem + ' - Erro ao carregar informações')
            this.$router.push('/')
          }
          this.loading_produtos = false
        })
      },

      async carregaClassificacao () {
        this.loading_produtos = true
        await ListaProdutos.listarClassificacao(localStorage.contrato_id).then(resposta => {
          if (resposta.data.status === true) {
            this.listaclassificacao = resposta.data.classificacao
            this.classificacaoOk = resposta.data.status
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else {
            this.showSnackbar('error', 3000, e.response.data.mensagem + ' - Erro ao carregar informações')
            this.$router.push('/')
          }
          this.loading_produtos = false
        })
      },

      async carregaProdutosLinha () {
        this.loading_produtos = true

        await ListaProdutos.listarProdutoLinha(this.linhaselected, localStorage.username, localStorage.contrato_id).then(resposta => {
          this.paginaVisible = false

          this.produtos = resposta.data.produto.map((item) => {
            var listaProdutos = ({
              id: item.id,
              idProduto: item.idProduto,
              nome: item.nome,
              unidade: item.unidade,
              preco: item.preco,
              precoExibicao: item.precoExibicao,
              linha_id: item.linha_id,
              idClassificacao: item.idClassificacao,
              pecasPorCaixa: item.pecasPorCaixa,
              precoForaUf: item.precoForaUf,
              desconto: item.desconto,
              pesoLiquido: item.pesoLiquido,
              pesoBruto: item.pesoBruto,
              referenciaUnidade: item.referenciaUnidade,
              referenciaUnidadeExibicao: item.referenciaUnidade.toFixed(2),
              peso: item.peso,
              dataInicio: item.dataInicio,
              dataFim: item.dataFim,
              imagem: item.imagem,
            })

            return listaProdutos
          })
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else {
            this.showSnackbar('error', 3000, e.response.data.mensagem + ' - Erro ao carregar informações')
            this.$router.push('/')
          }
          this.loading_produtos = false
        })
      },

      async carregaProdutosClassificacao () {
        this.loading_produtos = true
        await ListaProdutos.listarProdutoClassificacao(this.classificacaoselected, localStorage.username, localStorage.contrato_id).then(resposta => {
          this.paginaVisible = false

          this.produtos = resposta.data.produtoporClassificacao.map((item) => {
            var listaProdutos = ({
              id: item.id,
              idProduto: item.idProduto,
              nome: item.nome,
              unidade: item.unidade,
              preco: item.preco,
              precoExibicao: item.precoExibicao,
              linha_id: item.linha_id,
              idClassificacao: item.idClassificacao,
              pecasPorCaixa: item.pecasPorCaixa,
              precoForaUf: item.precoForaUf,
              desconto: item.desconto,
              pesoLiquido: item.pesoLiquido,
              pesoBruto: item.pesoBruto,
              referenciaUnidade: item.referenciaUnidade,
              referenciaUnidadeExibicao: item.referenciaUnidade.toFixed(2),
              peso: item.peso,
              dataInicio: item.dataInicio,
              dataFim: item.dataFim,
              imagem: item.imagem,
            })

            return listaProdutos
          })
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else {
            this.showSnackbar('error', 3000, e.response.data.mensagem + ' - Erro ao carregar informações')
            this.$router.push('/')
          }
          this.loading_produtos = false
        })
      },

      async carregaProdutosLinhaClassificacao () {
        this.loading_produtos = true
        await ListaProdutos.listarProdutoLinhaClassificacao(this.linhaselected, this.classificacaoselected, localStorage.username, localStorage.contrato_id).then(resposta => {
          this.paginaVisible = false

          this.produtos = resposta.data.produtoLinhaClassificacao.map((item) => {
            var listaProdutos = ({
              id: item.id,
              idProduto: item.idProduto,
              nome: item.nome,
              unidade: item.unidade,
              preco: item.preco,
              precoExibicao: item.precoExibicao,
              linha_id: item.linha_id,
              idClassificacao: item.idClassificacao,
              pecasPorCaixa: item.pecasPorCaixa,
              precoForaUf: item.precoForaUf,
              desconto: item.desconto,
              pesoLiquido: item.pesoLiquido,
              pesoBruto: item.pesoBruto,
              referenciaUnidade: item.referenciaUnidade,
              referenciaUnidadeExibicao: item.referenciaUnidade.toFixed(2),
              peso: item.peso,
              dataInicio: item.dataInicio,
              dataFim: item.dataFim,
              imagem: item.imagem,
            })

            return listaProdutos
          })
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else {
            this.showSnackbar('error', 3000, e.response.data.mensagem + ' - Erro ao carregar informações')
          }
          this.loading_produtos = false
        })
      },

      filtrar () {
        if (this.classificacaoselected.length > 0 && this.linhaselected.length === 0) {
          this.carregaProdutosClassificacao(this.classificacaoselected)
        } else if (this.linhaselected.length > 0 && this.classificacaoselected.length === 0) {
          this.carregaProdutosLinha(this.linhaselected)
        } else if (this.classificacaoselected.length > 0 && this.linhaselected.length > 0) {
          this.carregaProdutosLinhaClassificacao(this.linhaselected, this.classificacaoselected)
        } else {
          this.carregaProdutos()
        }
      },

      addItem (produto) {
        this.produtoNomes.push(produto)

        this.consultar = this.produtoNomes

        this.produtoNomes = this.produtoNomes.map((lista) => {
          var listacompra = ({
            id: lista.id,
            idProduto: lista.idProduto,
            nome: lista.nome,
            preco: lista.preco,
            precoExibicao: lista.precoExibicao,
            unidade: lista.unidade,
            quantidade: !lista.quantidade ? 1 : lista.quantidade,
            pecasPorCaixa: lista.pecasPorCaixa ?? 1, // lista.pecasPorCaixa : 1,
            estoque: lista.estoque,
            desconto: lista.desconto,
            referenciaUnidade: lista.referenciaUnidade,
            peso: lista.peso,
            dataInicio: lista.dataInicio ? lista.dataInicio : null,
            dataFim: lista.dataFim ? lista.dataFim : null,
            imagem: lista.imagem,
          })

          return listacompra
        })

        // função separa os produtos em grupos, caso o usuário clique em um produto
        // que já esteja no carrinho ele o agrupa os itens iguais
        function groupBy (array, f) {
          var groups = {}
          array.forEach(function (o) {
            var group = JSON.stringify(f(o))
            groups[group] = groups[group] || []
            groups[group].push(o)
          })
          return Object.keys(groups).map(function (group) {
            return groups[group]
          })
        }

        // percorrer os produtos do carrinho realizando a soma da quantidade dos itens
        // iguais da lista, realizando a soma da quantidade de cada produto
        // e entrega o array sem produtos repetidos
        var produtosIguais = groupBy(this.produtoNomes, function (item) {
          return [item.idProduto, item.nome]
        }).map((data) => {
          return {
            total: data.reduce((total, valor) => total + valor.quantidade, 0),
            itens: data,
          }
        })

        // preenche o array para ser usado na adição do carrinho
        for (var i in produtosIguais) {
          var id = produtosIguais[i].itens[0].id
          var idProduto = produtosIguais[i].itens[0].idProduto
          var nome = produtosIguais[i].itens[0].nome
          var preco = produtosIguais[i].itens[0].preco
          var precoExibicao = produtosIguais[i].itens[0].precoExibicao
          var unidade = produtosIguais[i].itens[0].unidade
          var quantidade = produtosIguais[i].total
          var pecasPorCaixa = produtosIguais[i].itens[0].pecasPorCaixa ?? 1
          var estoque = produtosIguais[i].itens[0].estoque
          var desconto = produtosIguais[i].itens[0].desconto
          var referenciaUnidade = produtosIguais[i].itens[0].referenciaUnidade
          var peso = produtosIguais[i].itens[0].peso
          var dataInicio = produtosIguais[i].itens[0].dataInicio
          var dataFim = produtosIguais[i].itens[0].dataFim
          var imagem = produtosIguais[i].itens[0].imagem

          this.carrinho[i] = {
            id: id,
            idProduto: idProduto,
            nome: nome,
            preco: preco,
            precoExibicao: precoExibicao,
            quantidade: quantidade,
            unidade: unidade,
            pecasPorCaixa: pecasPorCaixa ?? 1,
            estoque: estoque,
            desconto: desconto,
            referenciaUnidade: referenciaUnidade,
            peso: peso,
            dataInicio: dataInicio,
            dataFim: dataFim,
            imagem: imagem,
          }
        }

        // Percorrer todos os produtos e retornar apenas um item de cada
        this.produtoNomes = this.produtoNomes.filter(function (a) {
          return !this[JSON.stringify(a.idProduto)] && (this[JSON.stringify(a.idProduto)] = true)
        }, Object.create(null))

        if (this.consultar.length > this.produtoNomes.length) {
          if (this.bloqueado === 1) {
            this.showSnackbar('error', 10000, this.obsBloqueado)
          } else {
            this.showSnackbar(this.corPrimaria, 2000, 'Produto já estava no carrinho, foi adicionado mais um item do mesmo na lista de compra.')
          }
        } else {
          if (this.bloqueado === 1) {
            this.showSnackbar('error', 10000, this.obsBloqueado)
          } else {
            this.showSnackbar(this.corPrimaria, 2000, 'Produto adicionado com sucesso.')
          }
        }

        this.addCarrinho()
      },

      async addCarrinho () {
        const carrinho = this.carrinho.map((lista) => {
          var listacompra = ({
            id: lista.id,
            idProduto: lista.idProduto,
            nome: lista.nome,
            preco: lista.preco,
            precoExibicao: lista.precoExibicao,
            unidade: lista.unidade,
            quantidade: !lista.quantidade ? 1 : lista.quantidade,
            pecasPorCaixa: lista.pecasPorCaixa ?? 1,
            estoque: lista.estoque,
            desconto: lista.desconto,
            referenciaUnidade: lista.referenciaUnidade,
            peso: lista.peso,
            dataInicio: lista.dataInicio,
            dataFim: lista.dataFim,
            imagem: lista.imagem,
          })

          return listacompra
        })

        await Carrinho.cartAdd(carrinho, localStorage.username, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status === true) {
            this.itensCarrinho = resposta.data.itensCarrinho

            this.cart = carrinho.length

            this.updateCart()

            this.carregaForm()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.status === false) {
            this.showSnackbar('error', 10000, e.data.msg)
          }
        })

        this.carregaForm()
      },

      /* Método que envia as informações para buscar a descrição do produto */
      showDescricao (produto) {
        this.produtoid = produto.idProduto

        localStorage.setItem('produtoId', this.produtoid)
        localStorage.setItem('linhaSelect', JSON.stringify(this.linhaselected))
        localStorage.setItem('classificacaoSelect', JSON.stringify(this.classificacaoselected))

        this.$router.push('/descricao-produto')
      },

      /* Método que atualiza o ícone da quantidade itens no pedido */
      updateCart () {
        this.$root.$emit('update-cart', this.cart)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style lang="sass">
  #cart
    color: #ffffff
    text-decoration: none !important

  #line_product
    list-style-type: none
    overflow: auto
    height: 15em

  #classi
    list-style-type: none
    overflow: auto
    height: 15em

  #ul_product
    list-style-type: none

  #li_product
    border-style: none
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.3)
    width: 40%
    text-align: center
    float: left
    margin-right: 10px
    border-color: green

  #iconShopping
    margin-bottom: 9px

  #lista-produtos-form
    margin-top: 4em

  #btnProduto
    display: grid
    border-radius: 1.8rem
    margin: 1.5rem auto

  #btnDetalhe
    display: grid
    border-radius: 1.8rem
    margin: 1.5rem auto

  #btnFiltrar
    border-radius: 1.8rem

  #cartPosition
    top: 3rem

  #imgPromocao
    top: 1.5rem
    margin-left: 0.7rem

  #spanPromocao
    background-color: #E53935
    border-radius: 0.5rem

  #precoProduto
    font-size: 20px
    display: grid
    align-items: center
    margin: 0.7rem auto
    font-weight: bold

  #exibirReferenciaUnidade
    display: flex
    align-items: left
    font-size: 12px

  #nomeProdutoReferencia
    display: flex
    align-items: left
    font-weight: bold
    font-size: 12px
    color: transparent
    // margin: -1rem 0 0 0

  #unidadeProduto
    margin-top: 2.5rem
    display: flex
    align-items: left
    font-size: 12px

  #dataFim
    margin-top: -1.3rem

  #linhaHorizontal
    width: 100%
    border: 1px solid gray
    margin-top: 1rem

  #imagemProduto
    margin: auto

  #imagem
    margin: auto auto 1rem
    display: grid
    width: 256px
    height: 256px

</style>
